import { DownloadIcon, LoadingSkeleton } from '@bloomfieldrobotics/canopy';
import { IconButton } from '@mui/material';
import { useDownloadStageReport } from '../hooks/useDownloadStageReport';

type Props = {
  customerId: string;
  varietyId: string | undefined;
  shouldUpdate: boolean;
  loading: boolean;
};

export const DownloadStageReportButton = ({
  customerId,
  varietyId,
  shouldUpdate,
  loading,
}: Props) => {
  const { fileReady: stageReportFileReady, downloadFile: downloadStageReport } =
    useDownloadStageReport(customerId, varietyId, shouldUpdate);

  return (
    <LoadingSkeleton
      variant='rounded'
      loading={!stageReportFileReady || loading}
    >
      <IconButton
        size='small'
        sx={(theme) => ({
          color: theme.vars.palette.text.secondary,
          padding: 2,
          borderRadius: 1,
        })}
        onClick={downloadStageReport}
        disabled={!stageReportFileReady}
      >
        <DownloadIcon sx={{ width: '1rem', height: '1rem' }} />
      </IconButton>
    </LoadingSkeleton>
  );
};
